import { Component, OnInit, Input } from '@angular/core';
import { FormAccordion } from '../../models/form-field.model';
import { FormGroup } from '@angular/forms';
import { FormConfigInstance } from '../../services/form.service';

@Component({
  selector: 'gio-form-accordion',
  templateUrl: './form-accordion.component.html',
  styleUrls: ['./form-accordion.component.scss'],
  host: {
    '[style]': 'params.options?.hostStyle'
  },
})
export class FormAccordionComponent implements OnInit {

  @Input() form: FormGroup;
  @Input() service: FormConfigInstance;

  params: FormAccordion;
  constructor() { }

  ngOnInit(): void {
    this.params = this.service.params as any;
  }

}
